
import Dialog from "@mui/material/Dialog";

const Modal = (props) => {

  const {
    children,
    open
  } = props;

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={open}
      PaperProps={{
        style: {
          width: "600px",
        },
      }}
    >
      {children}
    </Dialog>
  );
}

export default Modal;
